module.exports = __webpack_public_path__ + "media/images/logo-a7aa3313b4b31e108b64c08a8f34d8dd.svg";